export default __webpack_public_path__ + "static/media/jpm-logo.375e71a9.svg";